import { Tag } from "antd";
import React from "react";

// ✅ Reusable tag function
export const AntTag = (amountWithVat) => (
  <Tag
    color="blue"
    style={{
      fontSize: "12px",
      padding: "2px 6px",
      lineHeight: "16px",
      marginLeft: 8,
    }}
  >
    AED {amountWithVat}
  </Tag>
);
